import { useEffect, useState } from "react";

import "./AboutSection.css";
import about1 from "../../assets/about/1.png";
import about2 from "../../assets/about/2.png";
import about3 from "../../assets/about/3.png";
import about4 from "../../assets/about/4.png";
import about5 from "../../assets/about/5.png";
import about6 from "../../assets/about/6.png";
import about7 from "../../assets/about/7.png";
import about8 from "../../assets/about/8.png";

const aboutSlides = [
  { image: about1, alt: "Trainosys training team and company logo" },
  { image: about2, alt: "Trainosys professional training solutions" },
  { image: about3, alt: "Trainosys global-ready learning" },
  { image: about4, alt: "Trainosys global-ready learning" },
  { image: about5, alt: "Trainosys global-ready learning" },
  { image: about6, alt: "Trainosys global-ready learning" },
  { image: about7, alt: "Trainosys global-ready learning" },
  { image: about8, alt: "Trainosys global-ready learning" },
];

function AboutSection() {
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveSlide((current) =>
        current === aboutSlides.length - 1 ? 0 : current + 1
      );
    }, 3500);

    return () => clearInterval(timer);
  }, []);

  return (
    <section className="home-about-section about-section" id="about">
      <div className="about-content">
        <p className="section-eyebrow">About Us</p>
        <h2>Training the future today through practical, global-ready learning</h2>
        <p className="about-lead">
          Trainosys Training Solutions is a leading provider of professional
          development and consulting services. Backed by a diverse team of
          Subject Matter Experts (SMEs) with extensive real-world experience,
          we are committed to optimizing the value of human capital investments.
        </p>

        <div className="about-card-grid">
          <article className="about-card">
            <span className="about-card-label">Mission</span>
            <p>
              To empower individuals and organizations worldwide by providing
              high quality, value-driven training and development programs.
            </p>
          </article>
          <article className="about-card">
            <span className="about-card-label">Vision</span>
            <p>
              To be the premier global training partner of choice for technology
              leaders and innovators worldwide.
            </p>
          </article>
        </div>

        <div className="about-image-slider">
          {aboutSlides.map((slide, index) => (
            <img
              key={index}
              src={slide.image}
              alt={slide.alt}
              className={`about-slider-image ${index === activeSlide ? "active" : ""}`}
            />
          ))}
        </div>

        <div className="learning-philosophy-card">
          <span className="about-card-label">Our Learning Philosophy</span>
          <p>
            At Trainosys, we believe that continuous learning is the engine of
            global innovation.
          </p>
        </div>
      </div>
    </section>
  );
}

export default AboutSection;
